// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qv-_U","largestCol":"styles_largestCol__HJA54","smallestCol":"styles_smallestCol__35Apk"};